import cart, { namespace as cartNamespace } from './modules/cart-store';
import appState, { namespace as appStateNamespace } from './modules/app-store';
import catalog, { namespace as catalogNamespace } from './modules/catalog-store';
import categoryFilters, { namespace as categoryFiltersNamespace } from './modules/category-filters-store';
import products, { namespace as productsNamespace } from './modules/product-store';
import user, { namespace as userNamespace } from './modules/user-store';
import userAuth, { namespace as userAuthNamespace } from './modules/auth-store';
import wishlist, { namespace as wishlistNamespace } from './modules/wishlist-store';
import cms, { namespace as cmsNamespace } from './modules/cms-store';
import promotions, { namespace as promotionsNamespace } from './modules/promotions-store';
import brands, { namespace as brandsNamespace } from './modules/brands-store';
import sets, { namespace as setsNamespace } from './modules/sets-store';

export default {
	[appStateNamespace]: appState(),
	[cartNamespace]: cart(),
	[catalogNamespace]: catalog(),
	[categoryFiltersNamespace]: categoryFilters(),
	[productsNamespace]: products(),
	[userNamespace]: user(),
	[userAuthNamespace]: userAuth(),
	[wishlistNamespace]: wishlist(),
	[cmsNamespace]: cms(),
	[promotionsNamespace]: promotions(),
	[brandsNamespace]: brands(),
	[setsNamespace]: sets(),
};
